<template src="./category.html"></template>
<script>
  import VueGallery from "vue-gallery";
  import Multiselect from "vue-multiselect";
  import Axios from "axios";
  import $ from "jquery";
  import TaskAction from "@/config/TaskAction.js";

  export default {
    components: {
      VueGallery,
      Multiselect,
    },
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "--";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },
      showstring: function (data) {
        if (data == "" || data == null) {
          return "";
        } else {
          return data.replaceAll("_", " ");
        }
      },
    },
    data() {
      return {
        basic: {
          currentPage: 1,
          totalPages: 0,
        },

        VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        ShowLoader: false,
        SearchForm: {
          Name: "",
        },
        CategoryList: [],
        ShowCategoryAddModel: "",
        SubmitCategory: {},
        ShowCategoryAdd: false,
        ShowCategoryEdit: false,
        ShowCategoryDelete: false,
      };
    },
    mounted() {
      /*var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions.Category || !AccountPermissions.Category.enable)
      ) {
        this.$router.push("/");
      }

      if (
        AccountPermissions &&
        AccountPermissions.Category &&
        AccountPermissions.Category.enable
      ) {
        if (AccountPermissions.Assets.Category.add) {
          this.ShowCategoryAdd = true;
        }
        if (AccountPermissions.Assets.Category.edit) {
          this.ShowCategoryEdit = true;
        }
        if (AccountPermissions.Assets.Category.delete) {
          this.ShowCategoryDelete = true;
        }
      }
      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowCategoryAdd = true;
        this.ShowCategoryEdit = true;
        this.ShowCategoryDelete = true;
      }*/
      this.ShowCategoryAdd = true;
      this.ShowCategoryEdit = true;
      this.ShowCategoryDelete = true;
      document.title = pbx_SiteTitle + " - Assets Category";
      this.GetCategoryList();
    },

    methods: {
      initSubmitCategoryObject() {
        this.SubmitCategory = {
          id: 0,
          parent_id: 0,
          name: "",
        };
      },
      GetCategoryList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        if (type == "search") {
          obj.name = this.SearchForm.Name;
        }
        this.ShowLoader = true;
        Axios.post(Endpoints.Assets.Category.List, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.CategoryList = Response.data.CategoryList;
          }
        });
      },
      AddNewCategory() {
        this.ShowCategoryAddModel = true;
        this.initSubmitCategoryObject();
      },
      EditCategory(category) {
        this.ShowCategoryAddModel = true;
        this.SubmitCategory = {};
        this.SubmitCategory.parent_id = category.parent_id;
        this.SubmitCategory.id = category.id;
        this.SubmitCategory.name = category.name;
      },
      AddCategorySubmit() {
        var error = false;
        var errorStr = "";
        if (!this.SubmitCategory.name) {
          error = true;
          errorStr += "<li>Please Enter Category Name</li>";
        }

        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(
            () => {}
          );
        } else {
          this.$swal({
            title: "Adding Category...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          var postUrl = Endpoints.Assets.Category.Create;
          if (this.SubmitCategory && this.SubmitCategory.id > 0) {
            postUrl = Endpoints.Assets.Category.Update;
          }
          Axios.post(postUrl, {
            token: localStorage.getItem("token"),
            SubmitCategory: this.SubmitCategory,
          }).then((Response) => {
            if (Response?.data?.success == true) {
              this.ShowCategoryAddModel = false;
              this.GetCategoryList();
              this.initSubmitCategoryObject();
              this.$swal("Category Added Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
            }
          });
        }
      },
      DeleteCategory(category) {
        this.$swal
          .fire({
            title: "Are you sure You want to Delete this Category?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete it!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal({
                title: "Deleting Category...",
                text: "Please wait...",
                imageUrl: require("@/assets/images/LoadingTwo.gif"),
                showConfirmButton: false,
                allowOutsideClick: false,
              });

              Axios.post(Endpoints.Assets.Category.Delete, {
                token: localStorage.getItem("token"),
                id: category.id,
              }).then((Response) => {
                if (Response?.data?.success == true) {
                  this.GetCategoryList();
                  this.$swal(
                    "Category Deleted Successfully",
                    "",
                    "success"
                  ).then(() => {});
                } else {
                  this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
                }
              });
            }
          });
      },
    },
  };
</script>
<style scoped>
  .parent-cat-no {
    font-weight: bold;
    color: #8f4f88 !important;
    font-size: 14px;
  }
</style>
